import { checkPin } from "@omony/domain";

/** Gleiche Regel wie der Server, zusätzlich „nicht unverändert“ */
export function checkPinClient(
  pin: string,
  current?: string,
): "pin_format" | "pin_trivial" | "pin_unchanged" | null {
  if (current && pin === current) return "pin_unchanged";
  return checkPin(pin);
}
